import React from 'react';
import styles from './WaveBoi.module.css';

export const WaveBoi: React.FunctionComponent = () => (
  <div className={styles.waveBoi} />
);
